import { render } from "./CampaignStats.vue?vue&type=template&id=2814edf6"
import script from "./CampaignStats.vue?vue&type=script&lang=js"
export * from "./CampaignStats.vue?vue&type=script&lang=js"

import "./CampaignStats.vue?vue&type=style&index=0&id=2814edf6&lang=css"

import exportComponent from "/Users/brianschroeter/Documents/Codex/2026-10-09/task/giving-dashboard-donor-fix/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__